import { useState, useEffect, useRef } from 'react';
import { EnvelopeSimple } from '@phosphor-icons/react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import Logo from '../components/Logo';

export default function PendingVerification() {
  const { user, resendVerification, logout } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(false);
  const sentOnMount = useRef(false);

  // Enviar email ao montar
  useEffect(() => {
    if (sentOnMount.current) return;
    sentOnMount.current = true;
    resendVerification().catch(() => {});
  }, [resendVerification]);

  // Polling a cada 5s para detectar verificacao
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const { data } = await api.get('/auth/me');
        if (data.user?.emailVerified) {
          const saved = JSON.parse(localStorage.getItem('user') || '{}');
          localStorage.setItem('user', JSON.stringify({ ...saved, emailVerified: true }));
          window.location.href = '/dashboard';
        }
      } catch {}
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  async function handleResend() {
    setSending(true);
    setError('');
    setSent(false);
    try {
      await resendVerification();
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao enviar email');
    } finally {
      setSending(false);
    }
  }

  async function handleCheck() {
    setChecking(true);
    setError('');
    try {
      const { data } = await api.get('/auth/me');
      if (data.user?.emailVerified) {
        const saved = JSON.parse(localStorage.getItem('user') || '{}');
        localStorage.setItem('user', JSON.stringify({ ...saved, emailVerified: true }));
        window.location.href = '/dashboard';
      } else {
        setError('Email ainda nao verificado');
      }
    } catch {
      setError('Email ainda nao verificado');
    } finally {
      setChecking(false);
    }
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm text-center">
        <div className="mb-8">
          <Logo />
        </div>

        <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-5">
          <EnvelopeSimple size={32} className="text-amber-500" />
        </div>

        <h2 className="text-xl font-bold text-slate-800 mb-2">Verifique seu email</h2>
        <p className="text-sm text-slate-400 mb-2">
          Enviamos um link de verificacao para
        </p>
        <p className="text-sm font-medium text-slate-700 mb-8">{user?.email}</p>

        {error && (
          <div className="bg-red-50 text-red-500 px-4 py-2.5 rounded-xl mb-4 text-sm border border-red-100">
            {error}
          </div>
        )}

        {sent && !error && (
          <div className="bg-emerald-50 text-emerald-600 px-4 py-2.5 rounded-xl mb-4 text-sm border border-emerald-100">
            Email reenviado!
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={handleCheck}
            disabled={checking}
            className="w-full bg-blue-600 text-white py-2.5 rounded-xl hover:bg-blue-700 transition text-sm font-medium shadow-sm disabled:opacity-50"
          >
            {checking ? 'Verificando...' : 'Ja verifiquei'}
          </button>

          <button
            onClick={handleResend}
            disabled={sending}
            className="w-full py-2.5 rounded-xl border border-slate-200 text-sm text-slate-600 hover:bg-slate-50 transition font-medium disabled:opacity-50"
          >
            {sending ? 'Enviando...' : 'Reenviar email'}
          </button>

          <button
            onClick={logout}
            className="w-full py-2.5 text-sm text-slate-400 hover:text-slate-600 transition"
          >
            Sair da conta
          </button>
        </div>
      </div>
    </div>
  );
}
